import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Typography, Box } from "@mui/material";
import { resetKiosk, resetWebshop } from "../../store/slice/Webshop.slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const InactivityPopup = ({ onConfirmCancel }) => {
  const navigate=useNavigate()
  const{key,widgetSetupId}=useSelector((store)=>store?.widgetSettings)
  const dispatch = useDispatch();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const timerRef = useRef(null); // Timer for inactivity
  const countdownRef = useRef(null); // Timer for countdown display
  const resetInactivityTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsPopupVisible(true);
      startCountdown();
    }, 10000); // 10 seconds
  };

  const startCountdown = () => {
    setCountdown(10); // Reset countdown
    if (countdownRef.current) clearInterval(countdownRef.current);
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          handleCancel();
          return 0;
        }
        return prev - 1;
      });
    }, 10000);
  };

  const handleUserActivity = () => {
    resetInactivityTimer(); // Reset the inactivity timer
    if (isPopupVisible) {
      setIsPopupVisible(false); // Hide popup if visible
      clearInterval(countdownRef.current); // Stop countdown
    }
  };

  const handleResetKiosk = () => {
    //dispatch(resetKiosk()); // Reset Redux state
    navigate(`/widget?widgetsetupid=${widgetSetupId}&key=${key}&resType=kiosk&position=vertical`); // Navigate to the previous page
    setTimeout(() => {
      handleResetKiosk()
      window.location.reload(); // Reload the page
    }, 100);
  };
  const handleCancel = () => {
     dispatch(resetWebshop());
   handleResetKiosk()
    setIsPopupVisible(false);
    resetInactivityTimer(); // Continue working
  };

  const handleConfirm = () => {
    setIsPopupVisible(false);
    if (onConfirmCancel) onConfirmCancel(); // Notify parent about cancellation
  };


  useEffect(() => {
    const handleUserActivity = () => {
      // Your logic to reset the inactivity timer
      resetInactivityTimer();
    };
  
    // List of common user activity events in a kiosk app
    const events = [
      "mousemove",       // Mouse movement
      "mousedown",       // Mouse click
      "keydown",         // Key press
      "touchstart",      // Touch screen interaction
      "touchmove",       // Touch drag/scroll
      "scroll",          // Scrolling with mouse/touch
      "click"            // Mouse or touchscreen click
    ];
  
    // Add all event listeners
    events.forEach(event => window.addEventListener(event, handleUserActivity));
  
    // Start the inactivity timer initially
    resetInactivityTimer();
  
    return () => {
      // Cleanup all event listeners on unmount
      events.forEach(event => window.removeEventListener(event, handleUserActivity));
  
      if (timerRef.current) clearTimeout(timerRef.current);
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
  }, []);
  

  return (
    <Modal open={isPopupVisible} onClose={handleCancel}>
      <Box
        sx={{
          padding: "20px",
          textAlign: "center",
          background: "white",
          margin: "15% auto",
          maxWidth: "400px",
          borderRadius: "10px",
          
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            fontSize: "48px",
            marginBottom: "10px",
            color: countdown > 5 ? "black" : "orange",
          }}
        >
          {countdown}s
        </Typography>
        <Typography variant="h5" sx={{ marginBottom: "10px" }}>
          Are you still here?
        </Typography>
        <Typography
          variant="body2"
          sx={{ marginBottom: "20px", color: "gray" }}
        >
          Lorem ipsum dolor sit amet consectetur. Molestie eu massa nunc
          consectetur eget erat nec.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCancel}
            sx={{
              backgroundColor: "#C4C4C4",
              "&:hover": { backgroundColor: "#A9A9A9" },
            }}
          >
            Cancel Order
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            sx={{
              backgroundColor: "#FF6F00",
              "&:hover": { backgroundColor: "#FF8C00" },
            }}
          >
            Yes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default InactivityPopup;

